import "core-js/modules/es.error.cause.js";
import countrySelectComp from "@/components/countrySelectComp.vue";
// import captchasInfoDIalog from "@/components/captchasInfoDIalog.vue";
export default {
  props: ["wechat_oa_token"],
  emits: ["noTeam", "changeLoginType"],
  components: {
    countrySelectComp
    // captchasInfoDIalog,
  },
  data() {
    return {
      aliCaptchaLoaded: false,
      isWeChat: this.$utils.isWX(),
      // 这里假设$utils已经通过Vue插件机制添加到Vue原型上
      isLoading: false,
      verification_key: "",
      phoneLoginFormData: {
        phone: "",
        code: "",
        prefix: "+86"
      },
      defaultCountrySelectedData: {
        areaName: "中国大陆",
        checkKey: "^(86){0,1}1\\d{10}$",
        code: "86",
        domainAbbreviation: "CN"
      },
      showPrefixPopup: false,
      countdown: 0,
      COUNTDOWN_START: 60,
      captchaInstance: null
    };
  },
  mounted() {
    this.initAliCaptcha({
      element: "#register-captcha-element",
      onError: this.onCaptchaError,
      onClose: this.onCloseCaptcha,
      onSuccess: this.onCheckCaptcha,
      getInstance: instance => {
        this.captchaInstance = instance;
      }
    });
  },
  methods: {
    onCaptchaError(err) {
      console.debug("onCaptchaError:>>>", err);
    },
    onCloseCaptcha() {
      var _this$captchaInstance, _this$captchaInstance2;
      // 关闭弹窗后刷新挑战状态，下次 show() 时出新题
      (_this$captchaInstance = this.captchaInstance) === null || _this$captchaInstance === void 0 || (_this$captchaInstance2 = _this$captchaInstance.refresh) === null || _this$captchaInstance2 === void 0 || _this$captchaInstance2.call(_this$captchaInstance);
    },
    onCheckCaptcha(code) {
      // console.log("onCheckCaptcha");
      this.getCaptches(code);
    },
    /**
     * 初始化阿里人机验证
     * @param param0
     * @param {string} param0.element
     * @param {string} param0.button
     * @param {(instance:any)=>void} param0.getInstance
     * @param {(captchaVerifyParam:any)=>void} param0.onSuccess
     * @param {(error:any)=>void} param0.onError
     * @param {()=>void} param0.onClose
     */
    initAliCaptcha(param0) {
      this.loadAliCaptchaScript().then(function () {
        const config = {
          SceneId: "1365vyei",
          mode: "popup",
          element: param0.element,
          success: param0.onSuccess,
          fail: param0.onError,
          onError: param0.onError,
          onClose: param0.onClose,
          getInstance: param0.getInstance,
          slideStyle: {
            width: 200,
            height: 40
          },
          language: "cn"
        };
        if (param0.button) {
          config.button = param0.button;
        }
        window.initAliyunCaptcha(config);
      });
    },
    loadAliCaptchaScript() {
      if (this.aliCaptchaLoaded) return Promise.resolve();
      if (window.initAliyunCaptcha) {
        this.aliCaptchaLoaded = true;
        return Promise.resolve();
      }
      return new Promise((resolve, reject) => {
        window.AliyunCaptchaConfig = {
          region: "cn",
          prefix: "o4dcro"
        };
        var _clear = console.clear;
        console.clear = function () {};
        var script = document.createElement("script");
        script.src = "https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js";
        script.onload = function () {
          console.clear = _clear;
          this.aliCaptchaLoaded = true;
          resolve();
        };
        script.onerror = function () {
          console.clear = _clear;
          reject(new Error("AliyunCaptcha 加载失败"));
        };
        document.head.appendChild(script);
      });
    },
    onConfirm(key) {
      this.verification_key = key;
    },
    validatorPhone(val) {
      let reg = new RegExp(this.defaultCountrySelectedData.checkKey);
      let isValid = reg.test(this.defaultCountrySelectedData.code + "" + val);
      if (isValid) {
        return true;
      } else {
        return "请输入正确的手机号";
      }
    },
    onSendCode() {
      if (!this.phoneLoginFormData.phone) {
        this.$toast({
          type: "fail",
          message: "请输入手机号",
          forbidClick: true
        });
        return false;
      }
      // this.$refs.captchasInfoDIalog.showDialog(this.phoneLoginFormData.phone, true);
      // this.getCaptches();
      this.captchaInstance && this.captchaInstance.show();
    },
    getCaptches(code) {
      this.$axios.sendSmsCode({
        mobile_number: this.phoneLoginFormData.phone,
        check_email_unique: 2,
        cf_turnstile_response: code
      }).then(res => {
        if (res.code === 1) {
          this.$notify({
            message: "验证码已发送，请注意查收短信！",
            type: "success"
          });
          this.verification_key = res.data.key;
          // this.$emit("onConfirm", res.data.key);
          // 开始倒计时
          this.countdown = this.COUNTDOWN_START;
          const intervalId = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(intervalId); // 倒计时结束，清除定时器
            }
          }, 1000); // 每秒更新一次倒计时
        }
      }).catch(() => {
        this.inputValue = "";
        this.loadCapts();
      });
    },
    onConfirmPrefix(value) {
      this.phoneLoginFormData.prefix = `+${value.code}`;
      this.showPrefixPopup = false;
      this.defaultCountrySelectedData = value;
    },
    goBack() {
      this.showPrefixPopup = false;
    },
    onSubmit() {
      this.isLoading = true;
      this.$axios.phoneLogin({
        verification_key: this.verification_key,
        verification_code: this.phoneLoginFormData.code,
        invite_id: this.$store.state.invite_id,
        wechat_oa_token: this.wechat_oa_token || ""
      }, true).then(res => {
        if (res.code === 1) {
          this.isLoading = false;
          this.$emit("success", res.data);
          // if (res.data.user_info.curr_team_id) {
          //   if (this.wechat_oa_token) {
          //     this.$router.push("/loginResult?type=1");
          //   } else {
          //     this.$router.push("/")
          //   }
          // } else {
          //   // 创建团队的流程
          //   this.$notify({
          //     message: "当前登录账号下无团队，请先创建团队",
          //     type: "danger",
          //     duration: 1000,
          //     onClose: () => {
          //       this.isLoading = false;
          //       this.$emit("noTeam")
          //     }
          //   });
          // }
        } else {
          this.isLoading = false;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    }
  }
};